import React from 'react';
import * as LucideIcons from 'lucide-react';

interface PromptFieldProps {
  id: string;
  title: string;
  description: string;
  placeholder: string;
  value: string;
  onChange: (id: string, value: string) => void;
  iconName: string;
}

export const PromptField: React.FC<PromptFieldProps> = ({
  id,
  title,
  description,
  placeholder,
  value,
  onChange,
  iconName
}) => {
  // @ts-ignore
  const IconComponent = LucideIcons[iconName] || LucideIcons.HelpCircle;

  return (
    <div className="bg-slate-800 border border-slate-700/50 rounded-lg p-4 transition-all hover:border-accent/30 shadow-md">
      <div className="flex items-start gap-3 mb-3">
        <div className="p-2 bg-accent/10 rounded-md text-accent shrink-0">
          <IconComponent size={20} />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-slate-50">{title}</h3>
          <p className="text-[11px] text-slate-400 mt-0.5 leading-tight">{description}</p>
        </div>
      </div>
      <textarea
        className="w-full bg-slate-950 border border-slate-700 rounded-md p-3 text-sm text-slate-200 placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-accent/50 focus:border-accent transition-all resize-none min-h-[80px]"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(id, e.target.value)}
      />
    </div>
  );
};
